import productReviewsJson from '@/assets/json/product-reviews.json';
export default {
  data() {
    return {
      showImportModal: false,
      manualReview: {
        id: null,
        fullName: '',
        avatar: '',
        star: 5,
        title: '',
        content: '',
        images: [],
        dateValue: new Date().toISOString().substr(0, 10),
        date: new Date().toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        }),
        like: 0,
        dislike: 0,
        results: 5,
        easeOfUse: 5,
        taste: 5,
        replies: [
          {
            content:
              "Thank you so much for your glowing feedback! We're thrilled that our products are fueling your energy and making such a positive difference in your life. We appreciate you spreading the word!",
          },
        ],
      },
      csvFile: null,
      csvLoading: false,
      csvError: null,
      importedReviews: [],
      formValid: true,
      isDragging: false,
      importTab: 0,
      randomReviewsCount: 10,
      maxRandomReviewsCount: 10,
      selectedGender: 'Unisex',
      genderOptions: [
        { text: 'Unisex', value: 'Unisex' },
        { text: 'Male', value: 'Male' },
        { text: 'Female', value: 'Female' },
      ],
      duplicateCount: 0,
      currentReviewImage: {
        src: '',
      },
      editingReviewIndex: null,
      editingImageIndex: null,
      //preview image dialog states
      reviewImageDialog: false,
      reviewEditDialog: false,
      previewImageDialog: false,
      previewImageSrc: '',
    };
  },
  methods: {
    formatDateToISO(date) {
      if (!date) return new Date().toISOString().substr(0, 10);
      const parsedDate = new Date(date);
      // Check if the date is valid
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate.toISOString().substr(0, 10);
      } else {
        // Fallback to current date if parsing fails
        return new Date().toISOString().substr(0, 10);
      }
    },
    formatDateToDisplay(date) {
      if (!date) date = new Date();

      // If it's already a Date object, use it directly
      let parsedDate;
      if (date instanceof Date) {
        parsedDate = date;
      } else {
        parsedDate = new Date(date);
      }

      // Check if the date is valid
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate.toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });
      } else {
        // Fallback to current date if parsing fails
        return new Date().toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });
      }
    },
    formatDateDisplay(dateValue) {
      if (!dateValue) return '';
      const parsedDate = new Date(dateValue);
      // Check if the date is valid
      if (!isNaN(parsedDate.getTime())) {
        return this.formatDateToDisplay(parsedDate);
      } else {
        return this.formatDateToDisplay(new Date());
      }
    },
    formatDateToExport(dateInput) {
      // Convert various date inputs to desired export format like:
      // Tue Aug 17 2025 11:30:31 GMT+0700 (Indochina Time)
      let parsed;
      if (!dateInput) {
        parsed = new Date();
      } else if (dateInput instanceof Date) {
        parsed = dateInput;
      } else {
        parsed = new Date(dateInput);
      }
      if (isNaN(parsed.getTime())) {
        parsed = new Date();
      }
      return parsed.toString();
    },

    //Function for import reviews - component
    handleDrop(e) {
      this.isDragging = false;
      const file = e.dataTransfer.files[0];
      this.validateAndImportFile(file);
    },
    handleFileSelect(e) {
      const file = e.target.files[0];
      this.validateAndImportFile(file);
      e.target.value = null;
    },
    validateAndImportFile(file) {
      if (!file) return;
      if (!file.name.endsWith('.csv')) {
        this.csvError = 'File must be a .csv';
        this.csvFile = null;
        return;
      }
      this.csvError = '';
      this.csvFile = file;
      this.importCsv(file);
    },
    async importCsv(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        this.csvLoading = true;
        this.csvError = '';
        this.importedReviews = [];

        reader.onload = e => {
          try {
            let text = e.target.result.replace(/^\uFEFF/, '');
            const lines = text.split(/\r?\n/).filter(l => l.trim() !== '');
            if (lines.length < 2) {
              this.csvError = 'CSV file must have a header and at least one row.';
              this.csvLoading = false;
              resolve(false);
              return;
            }

            const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
            const requiredHeaders = ['name', 'avatar', 'rating', 'title', 'content', 'date'];
            const missing = requiredHeaders.filter(h => !headers.includes(h));
            if (missing.length > 0) {
              this.csvError = `Missing required columns: <span style="text-transform: capitalize;">${missing.join(
                ', ',
              )}</span>`;
              this.csvLoading = false;
              resolve(false);
              return;
            }

            const imageCols = {};
            headers.forEach((h, i) => {
              const match = h.match(/^image(\d+)$/i);
              if (match) imageCols[parseInt(match[1], 10)] = i;
            });

            const rows = lines.slice(1);
            const chunkSize = 200;
            const processChunk = async start => {
              const end = Math.min(start + chunkSize, rows.length);

              for (let i = start; i < end; i++) {
                const cols = this.parseCsvLine(rows[i]);
                const row = {};
                headers.forEach((h, idx) => (row[h] = cols[idx] ? cols[idx].trim() : ''));

                let rating = parseInt(row.rating, 10);
                if (isNaN(rating) || rating < 1 || rating > 5) rating = 5;
                let avatar = this.isValidUrl(row.avatar) ? row.avatar : '';
                const images = Object.keys(imageCols)
                  .sort((a, b) => a - b)
                  .map(idx => {
                    const url = cols[imageCols[idx]];
                    return url && this.isValidUrl(url) ? { src: url, alt: '' } : null;
                  })
                  .filter(Boolean);

                let finalDate = new Date(row.date);
                if (isNaN(finalDate.getTime())) finalDate = new Date();

                this.importedReviews.push({
                  id: this.generateId(),
                  name: row.name || '',
                  avatar,
                  stars: rating,
                  title: row.title || '',
                  content: row.content || '',
                  images,
                  media: {
                    img: images.map(i => ({ url: i.src })),
                  },
                  dateValue: this.formatDateToISO(finalDate),
                  date: this.formatDateToDisplay(finalDate),
                  results: parseFloat(row.results, 10) || 5,
                  easeOfUse: parseFloat(row['ease of use'], 10) || 5,
                  taste: parseFloat(row['taste rated'], 10) || 5,
                  like: row['like'] || 0,
                  dislike: row['dislike'] || 0,
                  replies: [
                    {
                      content: row['reply'] || 'Thank you for your feedback!',
                    },
                  ],
                });
              }

              // wait for Vue update DOM
              await this.$nextTick();
              await new Promise(r => setTimeout(r, 0));

              if (end < rows.length) {
                await processChunk(end);
              } else {
                this.csvLoading = false;
                resolve(true);
              }
            };

            processChunk(0);

            // Auto-update total reviews count
            this.fields['total-reviewers'] = this.importedReviews.length;
            // Calculate duplicates within imported file (for tab v2 display)
            this.calculateDuplicateCount();
          } catch (err) {
            this.csvError = 'CSV parse error: ' + err.message;
            this.csvLoading = false;
            resolve(false);
          }
        };

        reader.onerror = () => {
          this.csvError = 'Failed to read file.';
          this.csvLoading = false;
          resolve(false);
        };
        reader.readAsText(file);
      });
    },
    parseCsvLine(line) {
      const result = [];
      let current = '';
      let insideQuotes = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === '"' && line[i + 1] === '"') {
          current += '"';
          i++;
        } else if (char === '"') {
          insideQuotes = !insideQuotes;
        } else if (char === ',' && !insideQuotes) {
          result.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      result.push(current);

      return result;
    },
    isValidUrl(url) {
      try {
        const u = new URL(url);
        return u.protocol === 'http:' || u.protocol === 'https:';
      } catch (_) {
        return false;
      }
    },
    handleExportReviews() {
      if (!this.fields.listItemReview || this.fields.listItemReview.length === 0) {
        return;
      }

      // Find the maximum number of images across all reviews
      const maxImages = Math.max(
        ...this.fields.listItemReview.map(review => (review.media ? review.media.img.length : 0)),
        0,
      );

      // Prepare CSV data with dynamic image columns
      const csvData = [];

      // Create header row with dynamic image columns
      // const headers = ['Id', 'Name', 'Avatar', 'Rating', 'Title', 'Content', 'Date']
      const headers = [
        'name',
        'avatar',
        'rating',
        'title',
        'content',
        'like',
        'dislike',
        'results',
        'ease of use',
        'taste rated',
        'reply',
        'date',
      ];
      for (let i = 1; i <= maxImages; i++) {
        headers.push(`Image${i}`);
      }
      csvData.push(headers);

      // Add data rows
      this.fields.listItemReview.forEach(review => {
        const row = [
          // review.id || '', // Id
          review.name || '', // Name
          review.avatar || '', // Avatar
          review.stars || 5, // Rating
          review.title || '', // Title
          review.content || '', // Content
          review.like || 0, // Like
          review.dislike || 0, // Dislike
          review.results || 5, // Results
          review.easeOfUse || 5, // Ease of Use
          review.taste || 5, // Taste
          review.replies[0].content || 'Thank you for your feedback!', // Reply
          this.formatDateToExport(review.date) || '',
        ];

        // Add image URLs based on actual number of images
        for (let i = 0; i < maxImages; i++) {
          if (review.media && review.media.img && review.media.img[i]) {
            row.push(review.media.img[i].url || '');
          } else {
            row.push(''); // Empty cell for missing images
          }
        }

        csvData.push(row);
      });

      // Convert to CSV string
      const csvContent = csvData
        .map(row =>
          row
            .map(cell => {
              // Escape quotes and wrap in quotes if contains comma, quote, or newline
              const escaped = String(cell).replace(/"/g, '""');
              if (escaped.includes(',') || escaped.includes('"') || escaped.includes('\n')) {
                return `"${escaped}"`;
              }
              return escaped;
            })
            .join(','),
        )
        .join('\n');

      // Create and download file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `product-reviews-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    calculateDuplicateCount() {
      const seen = new Set();
      let dup = 0;
      for (const r of this.importedReviews) {
        const key = `${r.fullName || ''}|||${r.avatar || ''}`;
        if (seen.has(key)) dup++;
        else seen.add(key);
      }
      this.duplicateCount = dup;
    },
    handleCloseImportModal() {
      this.showImportModal = false;
      this.handleRemoveCsvFile();
      this.importTab = 0;
      this.randomReviewsCount = 10;
      this.selectedGender = 'Unisex';
      this.csvError = '';
      this.csvFile = null;
      this.importedReviews = [];
      this.csvLoading = false;
      this.isDragging = false;
    },
    handleRemoveCsvFile() {
      this.csvFile = null;
      this.csvError = '';
      this.importedReviews = [];
      this.duplicateCount = 0;
      if (this.$refs.csvInput) {
        this.$refs.csvInput.value = null;
      }
    },
    generateId() {
      return (
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15)
      );
    },
    handleSaveAddReviews() {
      if (this.importTab === 0) {
        // Manual add
        const mv = this.manualReview;
        if (!mv || !mv.fullName) return;
        const newItem = {
          id: this.generateId(),
          name: mv.fullName || '',
          avatar: mv.avatar || '',
          stars: mv.star || 5,
          title: mv.title || '',
          content: mv.content || '',
          images: (mv.images || []).map(i => ({ src: i.src })),
          media: {
            img: (mv.images || []).map(i => ({ url: i.src })),
          },
          replies: mv.replies || [],
          like: mv.like || 0,
          dislike: mv.dislike || 0,
          dateValue: mv.dateValue || this.formatDateToISO(new Date()),
          date: mv.date || this.formatDateToDisplay(new Date()),
          results: mv.results || 5,
          easeOfUse: mv.easeOfUse || 5,
          taste: mv.taste || 5,
        };
        this.fields.listItemReview = [newItem, ...(this.fields.listItemReview || [])];
        // reset manual form
        this.manualReview = {
          id: null,
          fullName: '',
          avatar: '',
          star: 5,
          title: '',
          content: '',
          images: [],
          dateValue: new Date().toISOString().substr(0, 10),
          date: this.formatDateToDisplay(new Date()),
          replies: [
            {
              content:
                "Thank you so much for your glowing feedback! We're thrilled that our products are fueling your energy and making such a positive difference in your life. We appreciate you spreading the word!",
            },
          ],
          like: 0,
          dislike: 0,
        };
        this.$nextTick(() => this.$forceUpdate());
        this.handleCloseImportModal();
        return;
      }

      if (this.importTab === 1) {
        // Random
        // Generate random reviews
        if (
          !this.randomReviewsCount ||
          this.randomReviewsCount < 1 ||
          this.randomReviewsCount > this.maxRandomReviewsCount
        ) {
          return;
        }
        // Build a set of existing keys: fullName + avatar
        const existingKeySet = new Set(
          (this.fields.listItemReview || []).map(r => `${r.name || ''}|||${r.avatar || ''}`),
        );

        // Filter reviews by gender first
        let genderFilteredReviews = productReviewsJson;
        if (this.selectedGender !== 'Unisex') {
          genderFilteredReviews = productReviewsJson.filter(review => review.gender === this.selectedGender);
        }

        // Filter unique candidates from gender-filtered JSON that are not in existing
        const uniqueCandidates = genderFilteredReviews.filter(r => {
          const key = `${r.name || ''}|||${r.avatar || ''}`;
          return !existingKeySet.has(key);
        });

        // Shuffle candidates to keep randomness but ensure uniqueness
        const shuffled = uniqueCandidates
          .map(v => ({ v, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ v }) => v);

        const toAddCount = Math.min(this.randomReviewsCount, shuffled.length);
        const duplicateCount = Math.max(0, this.randomReviewsCount - toAddCount);

        let offsetDays = 0;
        for (let i = 0; i < toAddCount; i++) {
          const item = shuffled[i];
          // Push offset date random (1-7)
          offsetDays += Math.floor(Math.random() * 7) + 1;
          const pastDate = new Date();
          pastDate.setDate(pastDate.getDate() - offsetDays);
          pastDate.setHours(Math.floor(Math.random() * 24));
          pastDate.setMinutes(Math.floor(Math.random() * 60));
          pastDate.setSeconds(Math.floor(Math.random() * 60));

          this.fields.listItemReview.unshift({
            id: this.generateId(),
            name: item.fullName || ``,
            date: this.formatDateToDisplay(pastDate),
            dateValue: this.formatDateToISO(pastDate),
            stars: 5,
            results: 5,
            easeOfUse: 5,
            taste: 5,
            title: item.title || 'title',
            avatar: item.avatar || '',
            content: item.content || 'content',
            media: {
              img: [],
            },
            replies: [],
            like: 0,
            dislike: 0,
          });
        }

        // Show success message with counts
        if (toAddCount > 0) {
          let message = `Successfully added ${toAddCount} review${toAddCount > 1 ? 's' : ''}`;
          if (duplicateCount > 0) {
            message += `. ${duplicateCount} duplicate${duplicateCount > 1 ? 's' : ''} found and skipped`;
          }
          if (toAddCount < this.randomReviewsCount) {
            message += `. Could not add all ${this.randomReviewsCount} reviews due to duplicates`;
          }
          this.$store.dispatch('setMessage', { color: 'primary', dialog: true, content: message });
        } else if (duplicateCount > 0) {
          this.$store.dispatch('setMessage', {
            color: 'warning',
            dialog: true,
            content: `${duplicateCount} duplicate${duplicateCount > 1 ? 's' : ''} found. No new reviews added.`,
          });
        }

        this.$nextTick(() => {
          this.$forceUpdate();
        });
        this.handleCloseImportModal();
        return;
      }

      if (this.importTab === 2) {
        // Import from CSV
        if (!this.importedReviews.length) {
          this.csvError = 'Please upload a valid CSV file before saving.';
          return;
        }

        const seenInFile = new Set();
        const dedupImported = [];
        for (const r of this.importedReviews) {
          const key = `${r.name || ''}|||${r.avatar || ''}`;
          if (!seenInFile.has(key)) {
            seenInFile.add(key);
            dedupImported.push(r);
          }
        }

        const existing = this.fields.listItemReview || [];
        const uniqueImported = dedupImported.filter(
          r => !existing.some(e => (e.name || '') === (r.name || '') && (e.avatar || '') === (r.avatar || '')),
        );

        const skippedAgainstExisting = dedupImported.length - uniqueImported.length;
        const totalDuplicates = (this.duplicateCount || 0) + skippedAgainstExisting;

        this.fields.listItemReview = [...uniqueImported, ...existing];

        if (uniqueImported.length > 0) {
          let message = `Successfully imported ${uniqueImported.length} review${uniqueImported.length > 1 ? 's' : ''}`;
          if (totalDuplicates > 0) {
            message += `. ${totalDuplicates} duplicate${totalDuplicates > 1 ? 's' : ''} found and skipped`;
          }
          this.$store.dispatch('setMessage', { color: 'primary', dialog: true, content: message });
        } else {
          this.$store.dispatch('setMessage', {
            color: 'warning',
            dialog: true,
            content: 'All imported reviews are duplicates. No new reviews imported.',
          });
        }

        this.selectedReviews = []; // Clear selected reviews after import
        this.handleCloseImportModal();
        this.$forceUpdate();
      }
    },

    handleManualAddImage() {
      // Reuse review image dialog for manual form
      this.currentReviewImage = { src: '' };
      this.editingReviewIndex = null; // manual mode
      this.editingImageIndex = null;
      this.reviewImageDialog = true;
    },
    handleManualEditImage(imageIndex) {
      if (this.manualReview.images && this.manualReview.images[imageIndex]) {
        this.currentReviewImage = { src: this.manualReview.images[imageIndex].src };
        this.editingReviewIndex = null;
        this.editingImageIndex = imageIndex;
        this.reviewImageDialog = true;
      }
    },
    handlePreviewImage(src) {
      this.previewImageSrc = src;
      this.previewImageDialog = true;
    },

    // Function for review image dialog <------------------
    handleCancelReviewImageDialog() {
      this.reviewImageDialog = false;
      this.currentReviewImage = {
        src: '',
      };
      this.editingImageIndex = null;
      // Only reset editingReviewIndex if we're not in edit review dialog
      if (!this.reviewEditDialog) {
        this.editingReviewIndex = null;
      }
    },

    handleReviewImageUploaded(obj) {
      if (obj && obj.imageSrc) {
        this.currentReviewImage.src = obj.imageSrc;
      }
    },

    handleRemoveReviewImageDialog() {
      this.currentReviewImage.src = '';
    },
    handleSaveReviewImage() {
      if (!this.currentReviewImage.src) return;

      const imageData = { src: this.currentReviewImage.src };

      if (this.editingReviewIndex === null) {
        // Manual form mode
        if (!this.manualReview.images) this.manualReview.images = [];
        if (this.editingImageIndex !== null) {
          this.$set(this.manualReview.images, this.editingImageIndex, imageData);
        } else {
          this.manualReview.images.push(imageData);
        }
      } else if (this.editingImageIndex !== null) {
        // Editing existing review mode
        this.manualReview.images.splice(this.editingImageIndex, 1, imageData);
      } else {
        this.manualReview.images.push(imageData);
      }

      this.handleCancelReviewImageDialog();
    },
  },
};
